<template>
    <!-- <div
        ref="header"
        class="header sticky top-0"
        :class="{
            'px-20 pb-0': store.isOnMapAppPage,
            'z-50 bg-white pb-6': !store.isOnMapAppPage,
        }"
    > -->
    <header
        ref="header"
        class="header sticky top-0"
        :class="{
            'px-4 pb-0 md:px-10': store.isOnMapAppPage,
            'z-50 bg-white px-4 pb-6 md:px-0': !store.isOnMapAppPage,
        }"
    >
        <div
            ref="upperHeaderPart"
            class="mx-auto flex h-[85px] items-center justify-between border-b border-black-text bg-white pt-6 xl:h-[90px] xl:pt-4"
            :class="{
                'border-none': store.isOnMapAppPage,
            }"
        >
            <NuxtLink
                :to="localePath('/')"
                target="_self"
                class="flex items-center gap-4"
                aria-label="Link na domovskou stránku"
                no-prefetch
                @click="store.mobileMenuOpen = false"
            >
                <div class="w-40 xl:w-56">
                    <!-- <img
                        :src="
                            locale === 'en'
                                ? '/img/logo-portal-en.png'
                                : '/img/logo-portal.png'
                        "
                        class="relative top-1.5 w-full xl:top-3"
                        alt="Logo Portálu ÚAP"
                    /> -->
                    <img
                        :src="`/img/logo-portal-${locale}.png`"
                        class="relative top-1.5 h-16 max-w-none xl:top-3 xl:h-[5.5rem]"
                        alt="Logo Portálu ÚAP"
                    />
                </div>
            </NuxtLink>
            <nav
                v-if="!store.mobileMode"
                class="flex items-center gap-2 whitespace-nowrap text-sm lg:gap-3 lg:text-base xl:gap-9 print:hidden"
            >
                <NuxtLink
                    v-for="item in store.pages"
                    :key="item.to"
                    :to="localePath(item.to)"
                    class="px-2 py-0.5 font-promedium hover:bg-black-text hover:text-white xl:px-3"
                    :class="{
                        'bg-black-text': route.path.includes(item.to),
                        'text-white': route.path.includes(item.to),
                    }"
                    no-prefetch
                >
                    {{ useLocaleValue(item, "title") }}
                </NuxtLink>
            </nav>
            <div
                class="flex items-center gap-2 divide-x divide-black-text xl:gap-3 print:hidden"
            >
                <SearchInput v-if="!store.mobileMode" />
                <LanguageSwitcher v-if="!store.mobileMode" />
            </div>
            <div
                v-if="store.mobileMode"
                class="flex items-center gap-2 print:hidden"
            >
                <button
                    v-if="store.hasMobileLeftPanel"
                    type="button"
                    class="size-10 text-2xl"
                    @click="
                        store.mobileLeftPanelOpen = !store.mobileLeftPanelOpen
                    "
                >
                    <Icon name="custom:info" />
                </button>
                <button
                    type="button"
                    class="size-10 text-2xl"
                    @click="store.mobileMenuOpen = !store.mobileMenuOpen"
                >
                    <i class="pi pi-bars" />
                </button>
            </div>
            <UiSidebar
                v-if="store.mobileMode"
                :active="store.mobileMenuOpen"
            >
                <div class="flex flex-col items-center gap-3">
                    <SearchInput class="mb-4" />
                    <nav class="flex flex-col items-center gap-3">
                        <NuxtLink
                            v-for="item in store.pages"
                            :key="item.to"
                            :to="localePath(item.to)"
                            class="px-2 py-0.5 font-promedium hover:bg-black-text hover:text-white xl:px-3"
                            :class="{
                                'bg-black-text': route.path.includes(item.to),
                                'text-white': route.path.includes(item.to),
                            }"
                            no-prefetch
                            @click="store.mobileMenuOpen = false"
                        >
                            {{ useLocaleValue(item, "title") }}
                        </NuxtLink>
                    </nav>
                    <LanguageSwitcher class="mt-2" />
                </div>
            </UiSidebar>
        </div>
        <ClientOnly>
            <BreadCrumbs
                ref="crumbs"
                :class="{
                    'pointer-events-none invisible opacity-0':
                        store.isOnMapAppPage,
                    'pointer-events-auto visible opacity-100':
                        !store.isOnMapAppPage,
                }"
            />
        </ClientOnly>
    </header>
</template>

<script setup lang="ts">
import {
    /* useThrottleFn, useEventListener,  */ useElementSize,
} from "@vueuse/core"
const localePath = useLocalePath()
const store = useMainStore()
const route = useRoute()
const { locale } = useI18n()

const header = ref<HTMLElement | null>(null)
const upperHeaderPart = ref<HTMLElement | null>(null)

/* onMounted(() => {
    nextTick(() => {
        setHeaderHeight()
    })
}) */
//window.addEventListener("resize", () => throttle(setHeaderHeight, 100))

/* useEventListener(
    window,
    "resize",
    useThrottleFn(() => {
        setHeaderHeight()
    }, 100)
) */

watch(
    () => store.isOnMapAppPage,
    () => {
        nextTick(() => {
            setHeaderHeight()
        })
    }
)

const { height: headerHeight } = useElementSize(header)
watch(headerHeight, () => {
    // store.headerHeight = headerHeight.value
    setHeaderHeight()
})

function setHeaderHeight() {
    /* const breadcrumbsHeight = 48
    const padding = 24
    if (store.isOnMapAppPage) {
        store.headerHeight = upperHeaderPart.value
            ? upperHeaderPart.value.clientHeight
            : 0
    } else {
        store.headerHeight = upperHeaderPart.value
            ? upperHeaderPart.value.clientHeight + breadcrumbsHeight + padding
            : 0
    } */
    const upperHeight = upperHeaderPart.value
        ? upperHeaderPart.value.clientHeight
        : 0
    const fullHeight = header.value ? header.value.clientHeight : 0
    /* console.log("upperHeight", upperHeight)
    console.log("fullHeight", fullHeight) */
    if (store.isOnMapAppPage) {
        store.headerHeight = upperHeight
    } else {
        store.headerHeight = fullHeight
    }
}
</script>

<style></style>
